/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
//import { log } from 'utils/logger';
// import { history } from 'utils/history';
import { UPDATE_STEP_DETAILS } from 'state/actions/embedsState/embedManagementState/embed_management_status';


/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE > EMBED MANAGEMENT STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

// .......... STEP HELPERS .......... //

// moving items here will change the order in which they appear
// percentage will be calculated based on item index and array length
const stepQueue = [
    { name: 'placement', title: 'Select Placement' },
    { name: 'customize', title: 'Customize' },
    { name: 'ads', title: 'Select Ads' },
    { name: 'revenue', title: 'Revenue' },
    { name: 'code', title: 'Get Code' }
];
const stepQueueContent = stepQueue.map(step => step.name);

const defaultState = {
    stepQueue,
    stepQueueContent,
    currentStepPage: null, // this should match current page minus the forward slash and the string in stepQueue
    currentStepIndex: -1,
    totalNumberOfSteps: stepQueue.length,
    stepCompletionPercentage: 0
};

// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const embedManagementStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case UPDATE_STEP_DETAILS:
            newState['currentStepIndex'] = newState.stepQueue.findIndex(step => step.name === action.step);
            newState['currentStepPage'] = action.step !== 'library' ? action.step : '';
            newState['stepCompletionPercentage'] = Math.round(newState.currentStepIndex / (state.totalNumberOfSteps - 1) * 100);
           // console.log('UPDATE_STEP_DETAILS', action.step, newState)
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedManagementStatus;